/**
 * Imported first in main.tsx, before any schema is created: zod would otherwise test whether it may use eval
 * (it checks when each object schema is built), which our Content Security Policy blocks and Chrome logs.
 */
import { z } from "zod";

z.config({ jitless: true });
